import { Autocomplete, TextField, Checkbox, Grid } from "@mui/material";
import _ from "lodash";
import React from "react";

import { useUsersAndGroups } from "../../../../hooks/users";
import { language } from "../../../../language";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";

export default function PermissionTab(props) {
  const { handleCheckAuth, handleAutoCompleteChange, state, authMembers } =
    props;

  const { data: members } = useUsersAndGroups({});

  const editAuth = getUnitPropertie(state, "editAuth");
  const viewAuth = getUnitPropertie(state, "viewAuth");

  const options =
    members &&
    members.usersAndGroups?.map((option) => {
      return { id: option.id, isGroup: option.isGroup };
    }) || [];

  return (
    <Grid container spacing={2}>
      <Grid item size={12}>
        {members && (
          <Autocomplete
            multiple
            id="multiselect-users"
            options={options}
            value={authMembers}
            getOptionLabel={(option) => option.id}
            onChange={(e, value) => handleAutoCompleteChange(e, value)}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label={language.member}
                fullWidth
                helperText={language.toolTipMember}
              />
            )}
          />
        )}
      </Grid>

      <Grid item size={12}>
        <table className="table" style={{ textAlign: "center" }}>
          <thead>
            <tr>
              <th>{language.nome}</th>
              <th>{language.type}</th>
              <th>{language.permissionReadOnly}</th>
              <th>{language.permissionEdit}</th>
            </tr>
          </thead>
          <tbody>
            {authMembers &&
              authMembers.sort().map((item, index) => {
                return (
                  <tr key={`${item.id}${index}`}>
                    <td>{item.id}</td>
                    <td>
                      {item.isGroup
                        ? language.group
                        : language.datasourceUsuarioDB}
                    </td>
                    <td>
                      <Checkbox
                        onChange={(event) =>
                          handleCheckAuth(event, item, "viewAuth")
                        }
                        checked={
                          viewAuth &&
                          _.find(viewAuth, function (a) {
                            return a.id === item.id;
                          })
                        }
                      />
                    </td>
                    <td>
                      <Checkbox
                        onChange={(event) =>
                          handleCheckAuth(event, item, "editAuth")
                        }
                        checked={
                          editAuth &&
                          _.find(editAuth, function (a) {
                            return a.id === item.id;
                          })
                        }
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </Grid>
    </Grid>
  );
}
